import GtfsRealtimeBindings from "gtfs-realtime-bindings";
import _ from "lodash";
import L from "leaflet";
import 'leaflet/dist/leaflet.css';
const refreshInterval = 5000;

document.addEventListener('DOMContentLoaded', async () => {

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const mapLat = urlParams.get('lat') || 51.09259033203125;
  const mapLng = urlParams.get('lng') || -115.34565734863281;
  const mapZoom = urlParams.get('zoom') || 14;
  const mapRoutes = urlParams.get('routes').split(',') || 9506
  const mapshowBusIDs = urlParams.get('showBusIDs') === '1'
  const markerMovementTimers = [];

  let activeTrips = [];

  // Add layer for buses
  const busLayer = L.layerGroup();
  const routeLines = L.layerGroup();

  // Initialize Leaflet map
  const map = L.map('map', {zoomControl: false}).setView([mapLat, mapLng], mapZoom);

  //Initial fetch of routes
  let routes = await getRoutes();

  // Add OpenStreetMap tile layer
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  }).addTo(map);

  function getRoutes() {
    // Fetch GTFS data from API endpoint
    return fetch('https://dashboard.roamtransit.com/GTFSv2/populate_live_routes.php')
      .then(response => response.json())
      .then(fetchedRoutes => fetchedRoutes);

  }

  //function to interpolate position so that movement is smooth
  function moveMarker(marker, newPosition) {

    const oldPosition = marker.getLatLng();

    const deltaLat = ((oldPosition.lat - newPosition[0]) / 100);
    const deltaLng = ((oldPosition.lng - newPosition[1]) / 100);

    const interval = setInterval(() => {

      const currentMarkerPosition = marker.getLatLng();

      marker.setLatLng([currentMarkerPosition.lat - deltaLat, currentMarkerPosition.lng - deltaLng])

    }, refreshInterval / 100)

    markerMovementTimers.push(interval);

  }

  function plotActiveRoutes(entity) {

    const newActiveTrips = entity.map(record => {
        return mapRoutes.includes(record?.vehicle?.trip?.routeId) && record?.vehicle?.trip?.tripId;
      })
      .filter(record => {
        return record != false;
      });

    // Find additional routes
    const additions = _.difference(newActiveTrips, activeTrips);
    console.log("Additions", additions);

    // Find missing routes
     const deletions = _.difference(activeTrips, newActiveTrips);
     console.log("Deletions", deletions);

    routeLines.eachLayer((routeLine) => {

        if(!newActiveTrips.includes(routeLine.tripId)){
            if(routeLine.missedCount < 10){
                console.log("incrementing route missed counter");
                routeLine.missedCount++;
            }else{
                //if missed count is 10 or greater then remove the route line
                console.log("removing route line", routeLine)
                routeLines.removeLayer(routeLine);
            }
        }else{
            //zero out the missed count if the trip is present
            routeLine.missedCount = 0;
        }

    });

    activeTrips = newActiveTrips;

    routeLines.eachLayer((routeLine) => {
        console.log(routeLine)

    });

    //add route additions to map
    if(additions.length){
        fetch(`https://dashboard.roamtransit.com/GTFSv2/populate_routes_by_trip.php?trips=${additions.join(',')}`)
        .then(response => response.json())
        .then(shapes => {

            shapes.forEach((shape) => {
            const line = [];
            shape.shape.forEach((route) => {
                line.push([route.shape_pt_lat, route.shape_pt_lon])
            });

            const polyLine = L.polyline(line, {
                opacity: 0.8,
                smoothFactor: 1,
                weight: 5,
                color: `#${shape.shape_color}`
            }).addTo(routeLines);

            polyLine.tripId = shape.trip_id;
            polyLine.missedCount = 0;

            });

        });

        routeLines.addTo(map);
    }

  }

  // Function to fetch and plot real-time GTFS data
  function fetchAndPlotGTFSData(initialRun) {

    // Fetch GTFS data from API endpoint
    fetch(process.env.VEHICLE_LOCATION_ENDPOINT)
      .then(response => response.arrayBuffer())
      .then(buffer => {


        //stop markers from moving
        markerMovementTimers.forEach(timer => {
          clearInterval(timer);
        })

        markerMovementTimers.splice(0, markerMovementTimers.length);

        // Parse GTFS data
        const feed = GtfsRealtimeBindings.transit_realtime.FeedMessage.decode(new Uint8Array(buffer));

        if (feed.entity.length) {

          console.log("Entities", feed.entity)

          //plot route lines
          plotActiveRoutes(feed.entity);

          //loop through all markers already on the map
          busLayer.eachLayer((vehicle) => {
            
            console.log("Vehicle", vehicle);

            const filteredEntityItem = feed.entity.filter((entityItem) => {
                return entityItem.vehicle.vehicle.id == vehicle.vehicleId;
            });

            console.log('Filtered Entity', filteredEntityItem )

            //if the markers route has changed remove the marker it will be redrawn on the next function call.
            if(filteredEntityItem[0]?.vehicle?.routeId == vehicle.routeId){
                busLayer.removeLayer(vehicle)
            }

            //if the current marker isn't in the new fetched feed of live bus locations or it's trip ID is undefined
            if (filteredEntityItem.length == 0 || filteredEntityItem[0].vehicle.trip == null ) {
              //increment it's missed counter
              vehicle.missedCount = (vehicle.missedCount || 0) + 1;
              
              console.log('Missed one ', vehicle.vehicleId, vehicle.missedCount);
              //then if this bus hasn't reported in for the last 10 checkins, remove it.
              if (vehicle.missedCount > 10) {
                busLayer.removeLayer(vehicle)
              }
            
            
            //otherwise we're just going to update this markers position
            } else {

              //get the new bus item from the recently fetched feed
              const newPosition = feed.entity.filter((entityItem) => {
                return entityItem.vehicle.vehicle.id == vehicle.vehicleId;
              });

              //set missed count to zero
              vehicle.missedCount = 0;

              //update the markers position
              if (newPosition[0]?.vehicle?.position?.latitude && newPosition[0]?.vehicle?.position?.longitude) {

                if (!initialRun) {
                  
                    if(!newPosition[0]?.vehicle?.position?.latitude || !newPosition[0]?.vehicle?.position?.longitude){
                        busLayer.removeLayer(vehicle);
                    }else{
                        moveMarker(vehicle, [newPosition[0].vehicle.position.latitude, newPosition[0].vehicle.position.longitude]);
                    }
                  
                } else {
                    if(!newPosition[0]?.vehicle?.position?.latitude || !newPosition[0]?.vehicle?.position?.longitude){
                        busLayer.removeLayer(vehicle);
                    }else{
                        vehicle.setLatLng([newPosition[0].vehicle.position.latitude, newPosition[0].vehicle.position.longitude]);
                    }
                }

              }
            }
          });

          //generate an array of vehicle IDs on the map
          const busesOnMap = [];
          busLayer.eachLayer((bus) => {
            busesOnMap.push(bus.vehicleId)
          })

          // Iterate over entities (vehicles) in the feed
          feed.entity.forEach(entity => {

            //if the bus isn't already on the map and has a routeId then draw it
            if (entity.vehicle && entity?.vehicle?.trip?.routeId &&
              mapRoutes.includes(entity?.vehicle?.trip?.routeId) &&
              !busesOnMap.includes(entity.vehicle.vehicle.id)) {

              const vehicle = entity.vehicle;
              

              // Get vehicle position
              const position = vehicle.position;

              // Plot vehicle location on the map
              if (position?.latitude && position?.longitude && vehicle?.trip?.routeId) {

                const routeInfo = routes.filter((route) => {
                  return route.route_id == vehicle?.trip?.routeId
                });

                const iconColor = routeInfo[0]?.route_color || '#000';

                const markerHtmlStyles = `
                                background-color: #${iconColor};
                                opacity: 0.9;
                                width: 3rem;
                                height: 3rem;
                                display: flex;
                                left: -1.5rem;
                                top: -1.5rem;
                                position: relative;
                                border-radius: 3rem 3rem 0;
                                transform: rotate(45deg);
                                border: 2px solid #FFFFFF
                                `;


                const markerInnerStyles = `
                                display: inline-block;
                                position: absolute;
                                z-index: 10;
                                opacity: 1;
                                transform: rotate(-45deg);
                                width: 100%;
                                height: 100%;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                `;

                const markerTextStyles = `
                                background-color: #fff;
                                padding: 7px;
                                border-radius: 17px;
                                min-width: 20px;
                                text-align: center;
                                font-weight: bold;
                                font-size: 15px;
                                `;

                const busIdTextStyles = `
                                position: absolute;
                                opacity: 0.9;
                                background-color: #fff;
                                padding: 4px 10px;
                                border-radius: 17px;
                                border: 2px solid #${iconColor};
                                text-align: center;
                                font-weight: bold;
                                font-size: 15px;
                                transform: translateX(-50%) translateY(-10px);
                                `;

                const icon = L.divIcon({
                  iconAnchor: [4, 38],
                  labelAnchor: [-6, 0],
                  popupAnchor: [0, -36],
                  html: `<div style="${markerHtmlStyles}" ><div style="${markerInnerStyles}"><span style="${markerTextStyles}">${routeInfo[0].route_short_name}</span></div></div>${mapshowBusIDs ? `<div style="${busIdTextStyles}">${entity.vehicle.vehicle.id.substr(entity.vehicle.vehicle.id.length - 4)}</div>` : ``}`
                })

                const newMarker = L.marker([position.latitude, position.longitude], {
                  icon: icon
                })

                newMarker.vehicleId = entity.vehicle.vehicle.id
                newMarker.routeId = entity.vehicle.trip.routeId;
                newMarker.addTo(busLayer);
                
              }
            }

            //add all the markers to the map
            if (initialRun) {
              busLayer.addTo(map);
            }
          });
        }
      })
      //.catch(error => console.error('Error fetching GTFS data:', error));
  }


  // Call fetchAndPlotGTFSData and set up interval times
  setInterval(fetchAndPlotGTFSData, refreshInterval - 2000);

  // Call get routes every 100 seconds
  setInterval(async () => {
    routes = await getRoutes();
  }, 100000);

  // Initial fetch and plot
  fetchAndPlotGTFSData(true);

  //if tab / window focus is lost for whatever reason then replot markers without the animation (i.e. initialRun = true)
  document.addEventListener('visibilitychange', function (ev) {
    if (document.visibilityState === "visible")
      fetchAndPlotGTFSData(true);
  });
})